export default {
    path: 'header',
    component: () => import('../Header.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Đầu trang',
            component: () => import('../../table/Table.vue'),
        },
        {
            path: 'desktop/:id',
            name: 'Đầu trang cho máy tính',
            component: () => import('../../cu/CU.vue'),
        },
        {
            path: 'mobile/:id',
            name: 'Đầu trang cho di động',
            component: () => import('../../cu/CU.vue'),
        },
    ]
};